import React, { useEffect, useRef } from "react";
import axios from "axios";
import "./Karshenasi.css";
import { BsCheckLg, BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useState } from "react";
import moarefi from "../../Images/moarefi.jpg";
import Nazar from "../../Components/Nazar/Nazar";
import Question from "../../Components/Question/Question";
import banner from "../../Images/bannerKarshenasi.jpg";
import p1 from "../../Images/p1KarNem.jpg";
import p2 from "../../Images/p2KarNem.jpg";
import Carousel, { consts } from "react-elastic-carousel";
import MelkCard from "../../Components/MelkCard/MelkCard";
import ColorRadioButtons from "../../Components/FormCustom/Radio";
import ColorCheckboxes from "../../Components/FormCustom/CheckBox";
import Budges from "../../Components/FormCustom/Budges";
import SimpleAccordion from "../../Components/FormCustom/Acardion";
import useDocumentTitle from "../../Components/TitleSetter/useDocumentTitle";
import { MdChevronRight, MdKeyboardArrowLeft } from "react-icons/md";
import SliderItem from "../Home/SliderItem/SliderItem";
import Square from "../Home/Square";
import { useMediaQuery } from "react-responsive";
function Karshenasi(props) {
    useDocumentTitle("باهم | کارشناسی ملک");

    const [checkSazande, setCheckSazande] = useState(0);
    const [ghavanin, setGhavanin] = useState(0);
    const [stepper, setStepper] = useState(1);
    const res1000 = useMediaQuery({ query: "(max-width : 1000px)" });
    const res800 = useMediaQuery({ query: "(max-width : 800px)" });
    const res650 = useMediaQuery({ query: "(max-width : 650px)" });
    const res600 = useMediaQuery({ query: "(max-width : 600px)" });
    const res500 = useMediaQuery({ query: "(max-width : 500px)" });
    const res400 = useMediaQuery({ query: "(max-width : 400px)" });
    const res360 = useMediaQuery({ query: "(max-width : 360px)" });
    const myArrow = ({ type, onClick, isEdge }) => {
        const Pointer = type !== consts.PREV ? BsChevronLeft : BsChevronRight;
        return (
            <div className="arrowsStyleAgahiCardsWeb resArrowPints" onClick={onClick} disabled={isEdge}>
                <Pointer />
            </div>
        );
    };

    useEffect(() => {
        props.header.current.scrollIntoView({ behavior: "smooth" });
    }, []);
    const [requestReport, setRequestReport] = useState({
        fullName: "",
        phoneNumber: 0,
        address: "",
        visitingTime: "",
        discountCode: "",
    });
    function handleInputChange(event) {
        var targetId = event.target.id;
        var targetValue = event.target.value;
        setRequestReport((prev) => ({ ...prev, [targetId]: targetValue }));
    }

    const requestReportSet = () => {
        console.log(requestReport);
        var loginDialogOk = document.getElementById("loginDialogOk");
        var loginDialogErr = document.getElementById("loginDialogErr");
        if (requestReport.phoneNumber > 0) {
            console.log(requestReport);
            axios
                .post("https://hammaskan.ir:8443/api/reports/request", {
                    fullName: requestReport.fullName,
                    phoneNumber: requestReport.phoneNumber,
                    address: requestReport.address,
                    sazande: checkSazande,
                    visitingTime: requestReport.visitingTime,
                    discountCode: requestReport.discountCode,
                })
                .then((res) => {
                    console.log(res);
                    console.log(res.data.data);
                    loginDialogErr.style.display = "none";
                    loginDialogOk.style.display = "inline-block";
                    // setLoginPhoneState(loginPhone);
                    // setTimeout(() => {
                    //     setSwitch(11);
                    // }, 2000);
                })
                .catch((error) => {
                    console.log(error.response.data);
                    loginDialogOk.style.display = "none";
                    loginDialogErr.style.display = "inline-block";
                    if (error.response.data.message) {
                        loginDialogErr.textContent = error.response.data.message;
                    } else {
                        loginDialogErr.textContent = "امکان ثبت درخواست وجود ندارد";
                    }
                });
        } else {
            loginDialogOk.style.display = "none";
            loginDialogErr.style.display = "inline-block";
            loginDialogErr.textContent = "شماره تلفن خود را وارد نمایید";
        }
    };
    return (
        <div className="karshenasi">
            <div className="bannerKar">
                <img alt="" src={banner} />
            </div>
            <div className="requestFormKar">
                <div className="reqFormHeaderKar">
                    <h2>
                        فرم درخواست کارشناسی ملک با ضمانت <span>باهم</span>
                    </h2>
                </div>
                <div>
                    <div id="loginDialogOk" style={{ display: "none", width: "100%", backgroundColor: "#10ac84", color: "snow", padding: "8px", borderRadius: "8px", marginTop: "4px" }}>
                        درخواست شما با موفقیت ثبت و کارشناسان ما در کوتاه ترین زمان با شما تماس خواهند گرفت
                    </div>
                    <div id="loginDialogErr" style={{ display: "none", width: "100%", backgroundColor: "#ee5253", color: "snow", padding: "8px", borderRadius: "8px", marginTop: "4px" }}></div>
                    <div className="labelReqFormKar">نام و نام خانوادگی:</div>
                    <div className="inputReqFormKar">
                        <input type={"text"} id={"fullName"} onChange={handleInputChange} />
                    </div>
                    <div className="labelReqFormKar">شماره موبایل:</div>
                    <div className="inputReqFormKar">
                        <input type={"text"} id={"phoneNumber"} onChange={handleInputChange} />
                    </div>
                    <div className="labelReqFormKar">آدرس دقیق ملکی که قرار است کارشناسی شود</div>
                    <div className="inputReqFormKar TextAreaReqForm">
                        <textarea id={"address"} onChange={handleInputChange} />
                    </div>
                    <div className="smallTextReqFormerKarTextArea">
                        <span>باهم فعلا در منطقه 2 و 5 شهر تهران کارشناسی ملک را انجام می دهد.</span>
                    </div>
                    <div className="checkBoxReqFormKar">
                        <div className="CheckBoxComponentReqForm" onClick={() => setCheckSazande(!checkSazande)}>
                            {checkSazande ? <BsCheckLg style={{ color: "var(--color)", fontSize: "13px" }} /> : ""}
                        </div>
                        <div className="labelReqFormKarCheckBox">من سازنده هستم و درخواست کارشناسی بیش از یک ملک را دارم</div>
                    </div>
                    <div className="inputReqFormKar sazandePercentOff">سازندگان از تخفیف کارشناسی ویژه 50 درصدی بهره مند می شوند</div>
                    <div className="dateandcodeReqFormKar">
                        <div>
                            <div className="labelReqFormKar">زمان بازدید:</div>
                            <div className="inputReqFormKar">
                                <input type={"text"} id={"visitingTime"} onChange={handleInputChange} />
                            </div>
                        </div>
                        <div className="res780pointSpecialKar" style={{ marginRight: "25px" }}>
                            <div className="labelReqFormKar" style={{ color: "var(--color)" }}>
                                کد تخفیف
                            </div>
                            <div className="inputReqFormKar">
                                <input type={"text"} id={"discountCode"} onChange={handleInputChange} style={{ color: "var(--color)" }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="confirmAndPriceKarReqForm">
                    <div>
                        {/* <div className="CheckBoxComponentReqForm" onClick={() => setGhavanin(!ghavanin)}>
                            {ghavanin ? <BsCheckLg style={{ color: "var(--color)", fontSize: "13px" }} /> : ""}
                        </div> */}
                        <span></span>
                        {!res600 ? <div className="lineThroughReqConfirmKar"></div> : ""}
                        {!res600 ? <span className="gheimatkolSpanKar">هزینه کل:</span> : ""}
                    </div>
                    <div className="overAllPriceKar">
                        {res600 ? <span className="gheimatkolSpanKar">هزینه کل:</span> : ""}
                        <h3>
                            945/000/000 <span>تومان</span>
                        </h3>
                    </div>
                </div>
                <div className="recordAndPayKar">
                    <div className="recordAndPayBtnKar" onClick={requestReportSet}>
                        پرداخت و ثبت درخواست
                    </div>
                </div>

                <div className="informationBoxReqFormKar">
                    <div className="containerInfBoxReqFormKar">
                        <ul>
                            <li>فرایند بعد از ثبت درخواست کارشناسی ملک</li>
                            <li>قوانین و مقررات</li>
                        </ul>
                        <ul className="downListReqFormKar">
                            <li>شما می توانید به صورت تلفنی درخواست کارشناسی ملک خود را ثبت کنید شماره تماس : 02144262200</li>
                            <li>
                                ساعت کاری باهم:
                                <br />
                                هر روز بجز روزهای تعطیل رسمی ساعت 9:30 تا 20
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="stepperKarRow">
                <div className="stepperContainerKar">
                    <div className="reqFormHeaderKar">
                        <h2>
                            فرایند کارشناسی ملک با ضمانت <span>باهم</span>
                        </h2>
                    </div>
                    <div className="gridRowStepper">
                        <div className={["stepperItemKar stepperItemKar1", stepper >= 1 ? "stepperItemActive" : ""].join(" ")}>
                            <div className="stepperItemKarAbsolute">
                                <div className={stepper >= 1 ? "stepperItemKarAbsolutetraingleActive" : "stepperItemKarAbsolutetraingle"}></div>
                            </div>
                            <div className={["stepperHeaderKar", stepper >= 1 ? "stepperHeaderKarActive" : ""].join(" ")}>
                                <div className={["lineDashedKarHeaderStepper", stepper >= 1 ? "lineDashedKarHeaderStepperActive" : ""].join(" ")}></div>
                                <h3>ثبت سفارش کارشناسی ملک</h3>
                            </div>
                            <div className={["stepperParKar", stepper >= 1 ? "stepperParKarActive" : ""].join(" ")}>
                                <p>درخواست کارشناسی را در همین صفحه و یا به صورت تلفنی ثبت کنید</p>
                            </div>
                        </div>
                        <div className={["stepperItemKar stepperItemKar2", stepper >= 2 ? "stepperItemActive" : ""].join(" ")}>
                            <div className="stepperItemKarAbsolute">
                                <div className="stepperItemKarAbsolutetraingle">
                                    <div class="triangle1"></div>
                                </div>
                            </div>
                            <div className={["stepperHeaderKar", stepper >= 2 ? "stepperHeaderKarActive" : ""].join(" ")}>
                                <div className={["lineDashedKarHeaderStepper", stepper >= 2 ? "lineDashedKarHeaderStepperActive" : ""].join(" ")}></div>
                                <h3>حضور کارشناس باهم درمحل شما</h3>
                            </div>
                            <div className={["stepperParKar", stepper >= 2 ? "stepperParKarActive" : ""].join(" ")}>
                                <p>در زمان تعیین شده توسط شما کارشناس باهم در محل مورد نظر شما حضور می یابد</p>
                            </div>
                        </div>
                        <div className={["stepperItemKar stepperItemKar3", stepper >= 2 ? "stepperItemActive" : ""].join(" ")}>
                            <div className="stepperItemKarAbsolute">
                                <div className="stepperItemKarAbsolutetraingle">
                                    <div class="triangle1"></div>
                                </div>
                            </div>
                            <div className={["stepperHeaderKar", stepper >= 2 ? "stepperHeaderKarActive" : ""].join(" ")}>
                                <div className={["lineDashedKarHeaderStepper", stepper >= 2 ? "lineDashedKarHeaderStepperActive" : ""].join(" ")}></div>
                                <h3>کارشناسی تخصصی ملک</h3>
                            </div>
                            <div className={["stepperParKar", stepper >= 2 ? "stepperParKarActive" : ""].join(" ")}>
                                <p>کارشناس باهم به بررسی تخصصی بیش از 100 مورد مهم تعیین کننده در ارزش یک ملک می پردازد</p>
                            </div>
                        </div>
                        <div className={["stepperItemKar stepperItemKar4", stepper >= 2 ? "stepperItemActive" : ""].join(" ")}>
                            <div className="stepperItemKarAbsolute">
                                <div className="stepperItemKarAbsolutetraingle">
                                    <div class="triangle1"></div>
                                </div>
                            </div>
                            <div className={["stepperHeaderKar", stepper >= 2 ? "stepperHeaderKarActive" : ""].join(" ")}>
                                <div className={["lineDashedKarHeaderStepper", stepper >= 2 ? "lineDashedKarHeaderStepperActive" : ""].join(" ")}></div>
                                <h3>دریافت گزارش کارشناسی</h3>
                            </div>
                            <div className={["stepperParKar", stepper >= 2 ? "stepperParKarActive" : ""].join(" ")}>
                                <p>حدود 30 دقیقه بعد از انجام کارشناسی ، گزارش آن به صورت برخط (آنلاین) و بصورت کاغذی برای مشتری در دسترس است</p>
                            </div>
                        </div>
                        <div className={["stepperItemKar stepperItemKar5", stepper >= 2 ? "stepperItemActive" : ""].join(" ")}>
                            <div className={["stepperHeaderKar", stepper >= 2 ? "stepperHeaderKarActive" : ""].join(" ")}>
                                <div className={["lineDashedKarHeaderStepper", stepper >= 2 ? "lineDashedKarHeaderStepperActive" : ""].join(" ")}></div>
                                <h3>مشاور ملکی</h3>
                            </div>
                            <div className={["stepperParKar", stepper >= 2 ? "stepperParKarActive" : ""].join(" ")}>
                                <p>کارشناسان باهم جهت توضیح و مشاوره کامل گزارش کارشناسی ملک باهم، همچنین خرید یا فروش ملک های دیگر بصورت فرد به فرد تا پایان خرید یا فروش مشتری در کنار ایشان می باشند</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="moarefiBoxDivKar">
                <div className="moarefiHeaderKar">
                    <div className="moarefiImageKar">
                        <img alt="" src={moarefi} />
                    </div>
                    <div className="moarefiSquareKar"></div>
                    <h2>
                        معرفی کارشناسی ملک با ضمانت <span>باهم</span>
                    </h2>
                </div>
                <div className="moarefiTextKar">
                    <p>
                        عمدتا ما <span>بعد از خرید یک ملک</span> با ای سوال مواجه میشویم که:آیا همه مشخصات و ویژگی های مهم در خرید ملک را در نظر گرفتم؟ آیا بین دو یا چند ملکی که برای خرید شک دارم این ملک بهترین گزینه است؟ آیا این ملک با این شرایط و ویژگی ها بهترین قیمت را دارد؟ تصور کنید که{" "}
                        <span>می خواهید قبل از اینکه ملکی را بخرید</span> اطلاعاتی مستند، مستدل و کاربردی از آن ملک داشته ، آیا امکان پذیر است؟ اگر قرار باشد چکیده نظرات ده ها کارشناس ملکی در محله و منطقه را در قالب یک استاندارد بدون دخالت عامل انسانی و کاملا بصورت سیستماتیک و هم چنینی کارشناسی
                        تخصصی و حضوری این استاندارد توسط کارشناسان باهم را داشته باشید چطور ؟ آیا چنین چیزی موجود است؟
                        <br />
                        <br />
                        اگر بخواهیم از وضعیت موقعیت یا لوکیشن همسایگی کوچه ملک مورد نظر مثل وضعیت آنتن دهی موبایل و اینترنت کوچه، میزان شلوغی کوچه مورد نظر به نسبت محله، مشکلات شهروندی مطرح شده در کوچه،متوسط نرخ رشد قیمت در بازه 5 ساله، فاصله ملک خود تا مراکز مهم نظیر مدرسه ، مترو، بزرگراه و ...،
                        وضعیت قرارگیری در مسیر قنات در کوچه ملک مورد نظر، وضعیت احتمال وقوع زمین لغزش، وضعیت تیپ شهرسازی و جمعیت شناسی در همسایگی ملک مورد نظر با استفاده از داده های خام و آزاد منتشر شده توسط مراکز و سازمان های دولتی آگاه شویم چطور ؟ آیا ممکن است؟ آیا این داده ها توسط شرکت یا سازمانی
                        تضمین می شود؟ <span>باهم تمام این اطلاعات و شماوره ملکی را به صورت مستند به خریداران ملک </span>
                        ارایه می دهد. به همین منظور می توانید از خدمت کارشناسی ملک با ضمانت باهم استفاده کنید.
                    </p>
                </div>
            </div>

            <div className="nemoneKar">
                <div className="nemoneKarHeader">
                    <h2>
                        برای مشاهده نمونه نتیجه کارشناسی ملک با ضمانت <span>باهم</span> کلیک کنید
                    </h2>
                </div>
                <div className="cardsBackContainerKarNemone">
                    <div className="frontContainerKarNemone">
                        <div>
                            <img alt="" src={p2} />
                        </div>
                        <div>
                            <img alt="" src={p1} />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ margin: "40px auto", marginTop: "70px ", padding: res500 ? "20px 0px" : "30px 0px", width: res400 ? "103%" : res500 ? "98%" : "90%", backgroundColor: "" }}>
                <div className="reqFormHeaderKar">
                    <h2>
                        برخی از نظرات مشتریان <span>باهم</span>
                    </h2>
                </div>
                <div className="sliderRowNazarat">
                    <Carousel
                        className="sliderCompo"
                        pagination={true}
                        showArrows={res400 ? false : true}
                        isRTL={true}
                        renderArrow={myArrow}
                        renderPagination={({ pages, activePage, onClick }) => {
                            return (
                                <div className="paginationRowSlider2">
                                    {pages.map((page) => {
                                        const isActivePage = activePage === page;
                                        return <Square two key={page} page={page} click={onClick} active={isActivePage} />;
                                    })}
                                </div>
                            );
                        }}
                        itemsToShow={1}
                    >
                        <div className="nazarcontainerSlider">
                            <Nazar
                                name="آقای کاظم میقاتی"
                                rule={"خریدار ملک"}
                                image={" https://images.adsttc.com/media/images/55ef/aac4/e58e/ceb6/6500/00c2/large_jpg/004.jpg?1441770170"}
                                text="ممنونم از باهم بدلیل خدمات خاص و بدرد بخوری که ارایه می دن و باعث شد من با چشم باز خرید ملکم رو انجام بدم"
                            />
                        </div>
                        <div className="nazarcontainerSlider">
                            <Nazar
                                name="آقای دکتر علی نظری"
                                rule={"خریدار ملک"}
                                image={" https://images.adsttc.com/media/images/55ef/aac4/e58e/ceb6/6500/00c2/large_jpg/004.jpg?1441770170"}
                                text="برای من خیلی مهم بود که هر حرفی کارشناسان ملکی می زنن با سند باشه. اینکه باهم به صورت مستند به من اطلاعاتی از ملک مورد نظرم را دادن حس اطمینان زیادی بهم داد"
                            />
                        </div>
                        <div className="nazarcontainerSlider">
                            <Nazar
                                name="آقای مهندس پدرام عسگری"
                                rule={"خریدار ملک"}
                                image={" https://images.adsttc.com/media/images/55ef/aac4/e58e/ceb6/6500/00c2/large_jpg/004.jpg?1441770170"}
                                text="باهم باعث شد طعم شیرین مشاوره درست و سیستماتیک ملکی رو هم بچشیم و برای بنده بعنوان خریدار این خدمت باهم قابل تقدیر هستش."
                            />
                        </div>
                        <div className="nazarcontainerSlider">
                            <Nazar
                                name="آقای مهندس حسن شهری"
                                rule={"خریدار مسکن"}
                                image={" https://images.adsttc.com/media/images/55ef/aac4/e58e/ceb6/6500/00c2/large_jpg/004.jpg?1441770170"}
                                text="بنده یک فعال حوزه مسکن هستم و سال ها در زمینه خرید و فروش ملک فعالیت دارم اما گزارش کارشناسی باهم موضوعاتی رو عنوان کرده بود که من هم نمی دونستم."
                            />
                        </div>
                        <div className="nazarcontainerSlider">
                            <Nazar
                                name="سرکار خانم آتوسا سعیدی"
                                rule={"خریدار ملک"}
                                image={" https://images.adsttc.com/media/images/55ef/aac4/e58e/ceb6/6500/00c2/large_jpg/004.jpg?1441770170"}
                                text="می خواهم از مجموعه باهم یک تشکر ویژه بکنم .من و همسرم بین دو ملک که برای خرید دیده بودیم شک داشتیم. باهم با کارشناسی دقیق به ما کمک کرد که از انتخابمون رضایت کامل داشته باشیم و شک ما را به یقین تبدیل کرد."
                            />
                        </div>
                        <div className="nazarcontainerSlider">
                            <Nazar
                                name="سرکار خانم منا تبسمی"
                                rule={"فروشنده ملک"}
                                image={" https://images.adsttc.com/media/images/55ef/aac4/e58e/ceb6/6500/00c2/large_jpg/004.jpg?1441770170"}
                                text="به هر کجا برای آگاهی از قیمت واقعی ملکم مراجعه کردم گفتن ملک شما به این قیمت نمی ارزه اما الان که با این جزییات مشخصات ملک خودم رو با موارد مشابه که در سایت باهم وجود داره مقایسه می کنم بهم اثبات شد که قیمت اعلامی خودم برای فروش ملک کاملا منصفانه است."
                            />
                        </div>
                        <div className="nazarcontainerSlider">
                            <Nazar
                                name="آقای دکتر صحبت محمدی"
                                rule={"فروشنده ملک"}
                                image={" https://images.adsttc.com/media/images/55ef/aac4/e58e/ceb6/6500/00c2/large_jpg/004.jpg?1441770170"}
                                text="من برای فروش ملک خودم خیلی عجله داشتم از طرفی نمی خواستم به قیمت ارزون هم بفروشم. باهم با کارشناسی ملک من و بررسی فایل های مشابه به من کمک کرد که با خیال راحت ملکم رو بفروشم. فرآیند کارشناسی ملک هم با سرعت خیلی خوبی بود"
                            />
                        </div>
                        <div className="nazarcontainerSlider">
                            <Nazar name="آقای نیما شفیع خانی" rule={"خریدار ملک"} image={" https://images.adsttc.com/media/images/55ef/aac4/e58e/ceb6/6500/00c2/large_jpg/004.jpg?1441770170"} text="می خواهم تشکر کنم از مجموعه زحمتکش باهم. باورم نمیشه چنین اطلاعات جامع و کاملی حتی وجود داشته باشه." />
                        </div>
                    </Carousel>
                </div>
            </div>
            <div className="rowQuestionKar">
                <div className=""></div>
            </div>
            <div className="questionRowKar">
                <div className="verticalCrBtnKar">
                    <div className="soalatBtn">
                        <div className="soalBtnDashes"></div>
                        <span>سوالات شما</span>
                    </div>
                </div>
                <div className="verticalCrKar">
                    <div className="veritcalSliderKarBox"></div>
                    <div className="divForWidthKar">
                        <div className="sliderRowNazarat sliderRowNazaratQuestion">
                            <Carousel
                                className="sliderCompo"
                                pagination={true}
                                showArrows={false}
                                verticalMode
                                isRTL={true}
                                renderArrow={myArrow}
                                renderPagination={({ pages, activePage, onClick }) => {
                                    return (
                                        <div className="paginationRowSlider3">
                                            {pages.map((page) => {
                                                const isActivePage = activePage === page;
                                                return <Square two key={page} page={page} click={onClick} active={isActivePage} />;
                                            })}
                                        </div>
                                    );
                                }}
                                itemsToShow={1}
                            >
                                <div className="nazarcontainerSlider2">
                                    <Question
                                        question={"باهم کدام بخش های یک ملک را بررسی می کند؟"}
                                        text={"باهم ویژگی های ملک مورد نظر را به همراه فاکتورهای اثر گذار در ارزش یک ملک را کارشناسی می کند (بیش از 100 مورد تعیین کننده در ارزش یک ملک و تاثیرگذار در خرید یک ملک توسط مشتری) و مواردی مثل وضعیت لوله کشی ساختمان و مسایل حقوقی را کارشناسی نمی کند."}
                                    />
                                </div>
                                <div className="nazarcontainerSlider2">
                                    <Question question={"کارشناسان باهم چه ویژگی هایی دارند؟"} text={"کارشناسان باهم از افرادی تحصیل کرده با سال ها سابقه کاری در حوزه املاک تشکیل شده اند  و تمرکز آن ها بر روی رضایت مشتری می باشد"} />
                                </div>
                                <div className="nazarcontainerSlider2">
                                    <Question question={"آیا در صورت پشیمان شدن من از کارشناسی هزینه عودت داده می شود؟"} text={" فقط در صورتی که کارشناس بعد از هماهنگی با شما به محل اعزام نشده باشد این امکان وجود دارد . مبلغ پرداختی نیز ظرف کمتر از 1 روز کاری عودت داده خواهد شد."} />
                                </div>
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ margin: "40px auto", padding: "30px 0px", width: "600px", height: res650 ? "100px" : res800 ? "160px" : res1000 ? "220px" : "300px", backgroundColor: "" }}></div>

            <div className="sliderHomepage">
                <h4>مطالب آموزشی</h4>
                <div className="sliderItemsHomePage">
                    <Carousel
                        className="sliderCompo"
                        showArrows={false}
                        isRTL={true}
                        itemsToShow={res500 ? 3 : res600 ? 4 : res800 ? 3 : res1000 ? 2 : 3}
                        renderPagination={({ pages, activePage, onClick }) => {
                            return (
                                <div className="paginationRowSlider">
                                    {pages.map((page) => {
                                        const isActivePage = activePage === page;

                                        return <Square key={page} page={page} click={onClick} active={isActivePage} />;
                                    })}
                                </div>
                            );
                        }}
                    >
                        <div className="itemSliderComp">
                            <SliderItem
                                image={"https://blog.ipleaders.in/wp-content/uploads/2020/07/Real-Estate-Professionals.jpg"}
                                username={"Admin"}
                                date={"22 بهمن 1400 "}
                                time={"18:30"}
                                title={"مشاور فروشنده"}
                                text="مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی  "
                            />
                        </div>
                        <div className="itemSliderComp">
                            <SliderItem
                                image={"https://blog.hubspot.com/hubfs/Sales_Blog/real-estate-business-compressor.jpg"}
                                username={"Admin"}
                                date={"22 بهمن 1400 "}
                                time={"18:30"}
                                title={"مشاور فروشنده"}
                                text="مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی  "
                            />
                        </div>
                        <div className="itemSliderComp">
                            <SliderItem
                                image={"https://www.anthurium.in/wp-content/uploads/2019/06/First-Time-Commercial-Property-Buyers.jpg"}
                                username={"Admin"}
                                date={"22 بهمن 1400 "}
                                time={"18:30"}
                                title={"مشاور فروشنده"}
                                text="مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی  "
                            />
                        </div>
                        <div className="itemSliderComp">
                            <SliderItem
                                image={"https://blog.ipleaders.in/wp-content/uploads/2020/07/Real-Estate-Professionals.jpg"}
                                username={"Admin"}
                                date={"22 بهمن 1400 "}
                                time={"18:30"}
                                title={"مشاور فروشنده"}
                                text="مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی  "
                            />
                        </div>
                        <div className="itemSliderComp">
                            <SliderItem
                                image={"https://blog.hubspot.com/hubfs/Sales_Blog/real-estate-business-compressor.jpg"}
                                username={"Admin"}
                                date={"22 بهمن 1400 "}
                                time={"18:30"}
                                title={"مشاور فروشنده"}
                                text="مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی  "
                            />
                        </div>
                        <div className="itemSliderComp">
                            <SliderItem
                                image={"https://www.anthurium.in/wp-content/uploads/2019/06/First-Time-Commercial-Property-Buyers.jpg"}
                                username={"Admin"}
                                date={"22 بهمن 1400 "}
                                time={"18:30"}
                                title={"مشاور فروشنده"}
                                text="مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی  "
                            />
                        </div>
                        <div className="itemSliderComp">
                            <SliderItem
                                image={"https://blog.ipleaders.in/wp-content/uploads/2020/07/Real-Estate-Professionals.jpg"}
                                username={"Admin"}
                                date={"22 بهمن 1400 "}
                                time={"18:30"}
                                title={"مشاور فروشنده"}
                                text="مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی  "
                            />
                        </div>
                        <div className="itemSliderComp">
                            <SliderItem
                                image={"https://blog.hubspot.com/hubfs/Sales_Blog/real-estate-business-compressor.jpg"}
                                username={"Admin"}
                                date={"22 بهمن 1400 "}
                                time={"18:30"}
                                title={"مشاور فروشنده"}
                                text="مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی  "
                            />
                        </div>
                        <div className="itemSliderComp">
                            <SliderItem
                                image={"https://www.anthurium.in/wp-content/uploads/2019/06/First-Time-Commercial-Property-Buyers.jpg"}
                                username={"Admin"}
                                date={"22 بهمن 1400 "}
                                time={"18:30"}
                                title={"مشاور فروشنده"}
                                text="مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی مشاور فروش فردی است که زمانی که یک فرد تصمیم به اجاره یا فروش لک خود دارد، برای راهنمایی  "
                            />
                        </div>
                    </Carousel>
                </div>
                <div className="buttonRowSlider">
                    <div className="whatsBahamButtonHomeSlider">مشاهده مطالب آموزشی</div>
                </div>
                <div style={{ margin: "40px auto", padding: "30px 0px", width: "600px", backgroundColor: "" }}></div>
            </div>
        </div>
    );
}

export default Karshenasi;
